import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { checkSessionAction } from "../../Action/sessionAction";

export const PrivateRouteHooks = (pathName) => {
  const dataUser = JSON.parse(localStorage.getItem("LoginData"));

  const dispatch = useDispatch();

  useEffect(() => {
    if (dataUser) {
      dispatch(checkSessionAction({ id: dataUser.user_id }));
    }
  }, [pathName]);
};
